import React from "react";

// reactstrap components
import { Container, Row, Col, Button } from "reactstrap";
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import { DialogTitle, Dialog, DialogActions } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { appUrl } from '../../config';


// core components

class CompleteExamples extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      msgdiag: "",
      Inicio: {},
      selected: {}
    }
  }
  componentDidMount() {
    try {
      var Inicio = this.props.info.filter(function (hero) {
        return hero.value == "Inicio";
      });
      this.setState({ Inicio: Inicio[0] })
    } catch (error) {
      console.log("error", error)
    }
  }

  handleClickOpen = (event, msgdiag) => {
    this.setState({ open: true, msgdiag: msgdiag.text, selected: msgdiag._id });
  }

  handleClose = () => {
    this.setState({ open: false, msgdiag: "" });
  }
  handleChangetype = name => event => {
    this.setState({ [name]: event.target.value });
  };
  handleClick = (event) => {
    console.log("messa", this.state.msgdiag)
    var info =
      { _id: this.state.selected, text: this.state.msgdiag }

    fetch(appUrl + '/updateinfo', {
      method: 'post',
      body: JSON.stringify({
        info: info
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.props.onChange("info", {});
          alert('Información guardada')
        } else {
          alert('No se pudo guardar la información')
        }
      });

  };
  render() {
    return (
      <>
        <div className="section">
          <Container className="text-center">
            <Row className="justify-content-md-center">
              {this.props.admin ?
                <Tooltip title="Editar" aria-label="add">
                  <Fab variant="extended" onClick={event => this.handleClickOpen(event, this.state.Inicio)} >
                    <EditIcon />
                  </Fab>
                </Tooltip>
                : null}
              <Col lg="8" md="12">
                <h2 className="title">GPRO COLOMBIA es considerado PMF</h2>
                {/* {this.props.info.length > 0 ?
                  // <h3>{this.state.Inicio.text}</h3>
                  <h3>Texto Aqui</h3>

                  : null} */}
                <h3>Texto Aqui</h3>
              </Col>
              <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                minWidth="5000"
                maxWidth="10000"            >
                <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>Editar</h6></DialogTitle>
                <DialogContent>
                  <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                    <TextField
                      id="outlined-multiline-static"
                      fullWidth
                      value={this.state.msgdiag}
                      onChange={this.handleChangetype('msgdiag')}
                      multiline
                      variant="outlined"
                      rows="4"
                      InputProps={{
                        readOnly: this.state.showques ? true : false,
                      }}
                    />
                  </FormControl>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClick} color="primary" autoFocus>
                    Guardar
                  </Button>
                  <Button onClick={this.handleClose} color="primary" autoFocus>
                    Cancelar
                  </Button>
                </DialogActions>
              </Dialog>
            </Row>
          </Container>

        </div>
      </>
    );
  }
}

export default CompleteExamples;